module.exports = __webpack_public_path__ + "assets/img/noData.8162d668.png";